// src/services/PlanService.js
import APIService from "../modules/apiService";
import Helpers from "../modules/helpers";
import locales_es from "../locales/es";

const api = new APIService();
const helpers = new Helpers();

/**
 * Suscribe al plan, mostrando un modal de confirmación antes.
 * @param {string} planTag - Tag del plan (ej. 'PRO', 'FREE', etc.)
 * @param {function} showMainModal - Función para mostrar el modal (debe venir del componente)
 */
export function subscribeToPlanWithModal(planTag, showMainModal) {
  if (!showMainModal) return;

  showMainModal(
    `¿Suscribirse al plan ${planTag.toUpperCase()}?`,
    'Te llevaremos a la pasarela de suscripción para que puedas activar tu plan',
    null,
    [
      {
        label: locales_es.confirm,
        class: 'btn btn-success btn-elevate btn-pill btn-elevate-air',
        method: () => {
          confirmSubscription(planTag, showMainModal);
        }
      },
      {
        label: locales_es.cancel,
        class: 'btn btn-danger btn-elevate btn-pill btn-elevate-air',
      }
    ]
  );
}

/**
 * Confirma la suscripción al plan (llamada real a la API)
 * @param {string} planTag
 * @param {function} showMainModal
 */
export async function confirmSubscription(planTag, showMainModal) {
  try {
    const res = await api.postPlanSubscribe(planTag);

    if (res.data?.init_point) {
      window.open(res.data.init_point, '_self');
    } else {
      showMainModal?.(locales_es.successModal.title, res.message ?? locales_es.successModal.message);
    }
  } catch (err) {
    showMainModal?.(locales_es.errorModal.title, helpers.getErrorMsg(err));
  }
}
